import type { FuelSavingApplyPayload, FuelSavingApplyTrade } from '@makemydeal/dr-activities-fuel-saving';
import type { ScopeStateWithVehicle } from '../types';

export const getScopeVehicleVin = (scopeState: ScopeStateWithVehicle | undefined): string | undefined => {
    return scopeState?.vehicle?.vin;
};

export const isSuccessfulTrade = (trade: FuelSavingApplyTrade): boolean => trade.savings != null;

export const toSuccessfulApplyPayload = (payload: FuelSavingApplyPayload): FuelSavingApplyPayload => {
    const successfulVehicles = (payload.allVehicles ?? [])
        .map((vehicleEntry) => ({
            vehicle: vehicleEntry.vehicle,
            trades: vehicleEntry.trades.filter(isSuccessfulTrade)
        }))
        .filter((vehicleEntry) => vehicleEntry.trades.length > 0);

    return { allVehicles: successfulVehicles };
};

export const getVehiclesToUpdate = (
    payload: FuelSavingApplyPayload
): Array<{
    vehicle: { id: string; label: string; isPrimary?: boolean };
    trades: FuelSavingApplyTrade[];
}> => payload.allVehicles ?? [];
